export default __webpack_public_path__ + "static/media/hero-woman.665615b5.png";